"use strict";
exports.errors = {
    time: 'Delay is malformed or missing',
    expression: 'Expression is invalid',
    responseCapture: 'The duration for response capture is not valid',
    message: 'Message and/or Recipient requires selection',
    // eslint-disable-next-line max-len
    embeddedMessage: 'SMS and/or Email message needs to be fulfilled and Recipient requires selection',
    workflowValidation: 'Unable to start: Missing details',
    apiFault: 'Something went wrong. Please try again',
    invalidDelaySelection: 'No delay selections made',
    minimumDurationSelection: ({ minimumDurationMinutes }) => `Duration must be at least ${minimumDurationMinutes} minute${minimumDurationMinutes === 1 ? '' : 's'}`,
    emptyNodeError: 'Please delete or populate any empty branches',
};
//# sourceMappingURL=constants.js.map